<template>
    <div class="layout-notifications">
        <div id="range" class="component">
            <div class="middle" @click="open">
                <span class="pill pill-light pill-back" style="padding: 6px 8px 6px 8px">
                    <i class="material-icons">approval</i>
                </span>
                <span class="notification-count" v-if="hasQueuedRequests">{{ queuedRequestCount }}</span>
            </div>
        </div>
        <ui-modal ref="modal" title="Approvals" size="large">
            <table v-if="hasQueuedRequests" class="table">
                <thead>
                    <tr>
                        <th>Details</th>
                        <th style="width: 150px;">Date</th>
                        <th style="width: 150px;">Requested By</th>
                        <th style="width: 250px;"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="request in requests">
                        <td>
                            <a :href="requestUrl(request)">
                                <div style="font-weight: bold;">{{ request.definition.name }}</div>
                                <span>{{ request.subject.contact.primary_display_as }}</span>
                                <div>
                                    <span class="registration" style="margin-top: 5px; font-size: .7em; width: 75px; display: inline-block; margin-right: .8rem; padding: .45em 0; color: #42526e; font-weight: 500;">{{ vrm(request.subject.instance.vehicle) }}</span>
                                    <span v-if="request.subject.instance">{{ request.subject.instance.title }}</span>
                                </div>
                            </a>
                        </td>
                        <td>{{ request.created_at | formatDate }}</td>
                        <td>
                            <avatar :user="request.requested_by" style="margin-right: 10px;"></avatar>
                            {{ request.requested_by.name }}
                        </td>
                        <td class="text-right">
                            <ui-button size="small" color="green" icon="thumb_up" @click="approve(request)"></ui-button>
                            <ui-button size="small" color="red" icon="thumb_down" @click="confirmRejection(request)"></ui-button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-else>
                <hero-error-message title="No waiting approvals" icon="check_circle" accent-colour="forestgreen" style="margin-top: 2rem"></hero-error-message>
            </div>
        </ui-modal>
        <ui-modal ref="rejectConfirmation" title="Reject Request">
            <ui-textbox v-model="rejectionReason" :maxlength="50" enforce-maxlength label="Why are you rejecting this request?"></ui-textbox>
            <div slot="footer">
                <ui-button type="secondary" @click="$refs.rejectConfirmation.close()">Cancel</ui-button>
                <ui-button type="primary" color="primary" @click="$emit('rejection-confirmed')">Reject</ui-button>
            </div>
        </ui-modal>
    </div>
</template>

<script>
import {vrm} from "../filters/vehicle/vrm";
import Filters from '../filters'
import {ApprovalResource} from "../classes/Api/Approval";

export default {
    filters: Filters,
    mounted() {
        this.load()
    },
    methods: {
        vrm,
        open() {
            this.$refs.modal.open()
        },
        load() {
            ApprovalResource.all({ status: 'unapproved' }).then(r => {
                this.requests = r.data
            }).catch(handleApiError)
        },
        requestUrl(request) {
            if (request.subject_type === 'deal') {
                return this.$root.buildUrl('deals/' + request.subject_id + '/edit')
            }
        },
        approve(request) {
            if (confirm('Are you sure you want to APPROVE \'' + request.definition.name + '\'?')) {
                ApprovalResource.approve(request.id).then(r => {
                    this.load()
                }).catch(handleApiError)
            }
        },
        confirmRejection(request) {
            this.rejectReason = ''
            this.$refs.rejectConfirmation.open()
            this.$off('rejection-confirmed')
            this.$on('rejection-confirmed', () => {
                if (this.rejectionReason.length === 0) {
                    alert('You must specify why you are rejecting this request')
                    return
                }

                this.reject(request)
            })
        },
        reject(request) {
            if (confirm('Are you sure you want to REJECT \'' + request.definition.name + '\'?')) {
                ApprovalResource.reject(request.id, this.rejectionReason).then(r => {
                    this.load()
                    this.$refs.rejectConfirmation.close()
                }).catch(handleApiError)
            }
        }
    },
    data() {
        return {
            requests: [],
            rejectionReason: '',
        }
    },
    computed: {
        queuedRequestCount() {
            return this.requests.length
        },
        hasQueuedRequests() {
            return this.queuedRequestCount > 0
        }
    }
}
</script>

<style lang="scss">
.layout-notifications {
    .notification-count {
        background: #bc0101;
        font-size: 9px;
        display: inline-block;
        padding: 0px 4px;
        border-radius: 3px;
        color: #fff;
        position: absolute;
        right: -4px;
        top: -4px;
        opacity: 1 !important;
    }

    .ui-modal {
        color: #42526e;
    }

    .ui-modal--size-large .ui-modal__wrapper .ui-modal__container {
        width: 64rem;
    }
}
</style>